export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10494.19ab1437.jpg";